import { jsx, Fragment } from 'react/jsx-runtime';

const ItempropMetaData = ({ data, }) => data ? (jsx(Fragment, { children: Object.entries(data).map(([key, value], idx) => (jsx("meta", { itemProp: key, content: value }, idx))) })) : null;
ItempropMetaData.displayName = 'ItempropMetaData';

export { ItempropMetaData };
//# sourceMappingURL=ItempropMetaData.js.map
